import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {appContext} from '../../../../app.context';
import {ArchiSmallERRORS} from '../../../../commons/errors';

class ConservazioneCaricaDocumentoRegistroRifiutiStep2Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    $scope.pageHeader = 'Carica Documento';
    $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

    if (store.get('conservazioneClasseDocumentale') === null) {
      $state.go('home.conservazione-carica-documento-step1');
      return;
    }

    $scope.documentTypes = ['Beni', 'Servizi'];

    $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

    $scope.months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];


    $scope.years = [];
    const curr_year = new Date().getFullYear();
    for (let i = curr_year - 1; i <= curr_year; i++) {
      $scope.years.push(i);
    }
    const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {
      anno: number,
      scadenza: string
    }[];
    if (years) {
      for (let year of years) {
        if (new Date(year.scadenza) > new Date()) {
          $scope.years.push(year.anno);
        }
      }
    }

    $scope.cliente = {};
    $scope.anagraficaIsNew = true;
    $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');

    $scope.prev = () => {
      $scope.setConservazioneSettings();
      $state.go('home.conservazione-carica-documento-step1', {'classeDocumentale': $scope.classeDocumentale});
    };

    // <editor-fold desc='openWorkerModal'>

//
    $scope.openWorkerChatModal = (size) => {
      $scope.settings.meseRiferimento = $scope.months[$scope.settings.meseRiferimentoId];
      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'WorkerRegistroRifiutiModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: $scope.settings
        }
      });
    };
//

    $scope.openWorkerModal = (size) => {
      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');

      if ($scope.anagraficaIsNew) {
        $scope.saveAnagrafica();
      }

      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerRegistroRifiutiModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return $scope.settings;
          }
        }
      });
    };

    // </editor-fold>

    $scope.saveAnagrafica = () => {
      let anagrafica = {
        email_pec: '',
        emails: [],
        nome: $scope.settings.clienteNome,
        cognome: $scope.settings.clienteCognome,
        company_name: $scope.settings.clienteDenominazione,
        fiscal_code: $scope.settings.clienteCodiceFiscale,
        piva: $scope.settings.clientePIVA,
        type: $scope.settings.clienteDenominazione !== '' ? 2 : `${$scope.settings.clienteNome} ${$scope.settings.clienteCognome}`.trim() !== '' ? 1 : 2
      };

      ArchiSmallServices.insertAnagrafica(anagrafica)
        .then((response: any) => {
          // ??
        }, (error) => {
          if (error.errorCode !== ArchiSmallERRORS.DUPLICATE_KEY) {
            $rootScope.alert('error', 'Anagrafica già esistente');
          }
        });
    };

    $rootScope.formsubmitted = false;

    // <editor-fold desc='setConservazioneSettings'>
    $scope.setConservazioneSettings = () => {
      $scope.settings.clienteDenominazione = $scope.cliente.anagrafica;
      let classeDocumentale = $scope.settings.classeDocumentale.key;
      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response: any) => {
          // ??
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;
      $scope.currentClasseDocumentale = $scope.classeDocumentale;
      ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
        .then((response: any) => {
          if (response !== undefined && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
          } else {
            $scope.settings = $scope.getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    if ($scope.classeDocumentale !== '') {
      $scope.getConservazioneSettings();
    }

    $scope.dpOpened = {
      dataDocumento: false,
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };

    /* tslint:disable:no-string-literal */
    $scope.autoOpen = ($event, opened) => {
      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    /* tslint:enable:no-string-literal */
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };
  }
}

export const ConservazioneCaricaDocumentoRegistroRifiutiStep2Component: ng.IComponentOptions = {
  template: require('./conservazione-carica-documento-registro-rifiuti-step2.html'),
  controller: ConservazioneCaricaDocumentoRegistroRifiutiStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-rifiuti-step2/conservazione-carica-documento-registro-rifiuti-step2.ts